import { useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Asterisk, Menu, X } from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const goToSets = () => {
    setOpen(false);
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById("starter-packs")?.scrollIntoView({ behavior: "smooth" }), 400);
    } else {
      document.getElementById("starter-packs")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const linkCls = ({ isActive }) =>
    `font-display font-bold uppercase tracking-tight text-sm transition-colors duration-150 hover:text-blue ${
      isActive ? "text-blue" : "text-charcoal"
    }`;

  return (
    <header data-testid="navbar" className="sticky top-0 z-50 border-b-2 border-charcoal bg-cream">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-1 font-display text-xl font-extrabold uppercase tracking-tight">
          Stay Retro <Asterisk className="h-5 w-5 text-coral" strokeWidth={3} />
        </Link>
        <nav className="hidden items-center gap-8 md:flex">
          <NavLink to="/shop" data-testid="nav-shop-link" className={linkCls}>Shop</NavLink>
          <button onClick={goToSets} data-testid="nav-sets-link" className="font-display text-sm font-bold uppercase tracking-tight text-charcoal transition-colors duration-150 hover:text-blue">
            Starter Packs
          </button>
          <NavLink to="/about" data-testid="nav-about-link" className={linkCls}>About</NavLink>
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/shop" data-testid="nav-shop-cta" className="btn-chunky hidden bg-blue px-5 py-2 text-sm text-white hover:bg-coral md:inline-flex">
            Shop the 90s
          </Link>
          <button
            onClick={() => setOpen(!open)}
            data-testid="nav-menu-toggle"
            aria-label="Toggle menu"
            className="rounded-full border-2 border-charcoal p-2 shadow-hard-sm transition-transform duration-150 hover:-translate-y-0.5 md:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
            data-testid="nav-mobile-menu"
            className="overflow-hidden border-t-2 border-charcoal bg-cream md:hidden"
          >
            <div className="flex flex-col gap-4 px-4 py-6">
              <NavLink to="/shop" onClick={() => setOpen(false)} data-testid="nav-mobile-shop" className="font-display text-2xl font-extrabold uppercase tracking-tight">Shop</NavLink>
              <button onClick={goToSets} data-testid="nav-mobile-sets" className="text-left font-display text-2xl font-extrabold uppercase tracking-tight">Starter Packs</button>
              <NavLink to="/about" onClick={() => setOpen(false)} data-testid="nav-mobile-about" className="font-display text-2xl font-extrabold uppercase tracking-tight">About</NavLink>
              <Link to="/shop" onClick={() => setOpen(false)} data-testid="nav-mobile-cta" className="btn-chunky mt-2 bg-blue px-6 py-3 text-white">
                Shop the 90s
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
